import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4"},[_c(VSwitch,{staticClass:"font-weight-bold mt-0",attrs:{"inset":"","hide-details":"","label":_vm.label},model:{value:(_vm.$vuetify.theme.dark),callback:function ($$v) {_vm.$set(_vm.$vuetify.theme, "dark", $$v)},expression:"$vuetify.theme.dark"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }